import raw from './pagalo-categories.json'

export interface CommerceTypeInfo {
  name: string
  code: string
}

export const commerceTypes: CommerceTypeInfo[] = raw

export type CommerceType = (typeof commerceTypes)[number]['code']

export function getCommerceTypeInfo(code: CommerceType): CommerceTypeInfo | undefined {
  return commerceTypes.find(t => t.code === code)
}
